export default {
    props: ['name'],

    data: function() {
        return {}
    },
}


// WEBPACK FOOTER //
// ./resources/assets/front/js/components/vgb-icon/script.js